<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="63" viewBox="0 0 80 63" fill="none">
        <path d="M3 17.9111C3 16.8556 3.85564 16 4.91112 16H58.104C59.1511 16 60 16.8489 60 17.896V42.0061C60 51.3048 53.2678 59.2364 44.0927 60.7475V60.7475C43.0724 60.9156 42.0401 61 41.0061 61H21.1491C20.1113 61 19.0754 60.911 18.0528 60.7339V60.7339C9.35343 59.2277 3 51.6797 3 42.8509V17.9111Z" fill="#85D1F2"/>
        <path d="M2 1.5H61C61.2761 1.5 61.5 1.72386 61.5 2V41.5058C61.5 50.9745 54.8582 59.1449 45.5889 61.0786C44.2459 61.3588 42.8777 61.5 41.5058 61.5H20.5643C19.1911 61.5 17.8218 61.3516 16.4804 61.0574C7.733 59.139 1.5 51.3909 1.5 42.4356V2C1.5 1.72386 1.72386 1.5 2 1.5Z" stroke="#633000" stroke-width="3"/>
        <path d="M61.5 15.5H64.5C72.232 15.5 78.5 21.768 78.5 29.5C78.5 37.232 72.232 43.5 64.5 43.5H61.5V15.5Z" stroke="#633000" stroke-width="3"/>
        <circle cx="13" cy="14" r="5" fill="#B8EAFF"/>
        <circle cx="13" cy="14" r="5" fill="#B8EAFF"/>
        <circle cx="13" cy="14" r="5" fill="#B8EAFF"/>
        <circle cx="26" cy="19" r="5" fill="#B8EAFF"/>
        <circle cx="26" cy="19" r="5" fill="#B8EAFF"/>
        <circle cx="26" cy="19" r="5" fill="#B8EAFF"/>
        <circle cx="38" cy="9" r="5" fill="#B8EAFF"/>
        <circle cx="38" cy="9" r="5" fill="#B8EAFF"/>
        <circle cx="38" cy="9" r="5" fill="#B8EAFF"/>
        <circle cx="51" cy="16" r="5" fill="#B8EAFF"/>
        <circle cx="51" cy="16" r="5" fill="#B8EAFF"/>
        <circle cx="51" cy="16" r="5" fill="#B8EAFF"/>
      </svg>
</template>